module.exports = __webpack_public_path__ + "static/img/wxscr2.4b3f45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxscr2.png
// module id = NIAA
// module chunks = 0